import classnames from "classnames";
import LayoutIcon from "react-feather/dist/icons/layout";

import style from "./style.module.scss";
import { Layout, LayoutPreview } from "../layout";
import layouts from "../layout/layouts";
import { ArrowSelector } from "../../../../ui";
import { stripPhotoTransforms } from "../../../../media/utils/photo-transform";
import type { PageOptions } from "../../../types";

interface PageProps {
  page?: PageOptions;
  index: number;
  count: number;
  onChange: (page: PageOptions) => void;
  productId?: string;
  userId?: string;
}

interface PagePreviewProps {
  page?: PageOptions;
}

function Page({ page = {}, index, count, onChange, productId, userId }: PageProps) {
  const { layout: layoutKey = "margin" } = page;
  const onChangeLayout = (layout: string) => {
    // Reset photo transforms when layout changes since aspect ratios are different
    const photos = stripPhotoTransforms(page.photos);
    onChange({ ...page, layout, photos });
  };

  return (
    <div className={style.container} key={index}>
      <div className={style.config}>
        <ArrowSelector
          options={layouts}
          value={layoutKey}
          onChange={onChangeLayout}
          renderLabel={(label) => (
            <span className={style.layoutLabel}>
              <LayoutIcon width={18} height={18} />{" "}
              <span className={style.formatPrefix}>Format : </span>
              <span className={style.formatName}>{label}</span>
              <span className={style.page}>
                P. {index}/{count}
              </span>
            </span>
          )}
          classNames={{
            label: style.layoutLabel,
          }}
        />
      </div>
      <div className={classnames(style.layout, style.pageContainer)}>
        <Layout page={page} onChange={onChange} productId={productId} userId={userId} />
      </div>
    </div>
  );
}

Page.Preview = ({ page = {} }: PagePreviewProps) => (
  <div className={style.pageContainer}>
    <LayoutPreview page={page} />
  </div>
);

export default Page;
